<template>
    <b-form-select v-model="provinceProduct.discount_rules_id"
                   :options="discountActivationsOpt"
                   size="sm"
    />
</template>
<script>
import store from "./store";

export default {
    name: 'select-discount-rule',
    props: {
        provinceProduct: {}
    },
    computed: {
        discountActivationsOpt() {
            return [
                { value: null, text: 'null' },
                ...store.discountActivations.map(i => ({ value: i._id, text: i.name }))
            ];
        },
    }
}
</script>
